import { api, buildQueryString } from '@/api';
import { TEMPLATE_LIST_TAG } from '@/api/constants';
import { TemplateType } from './types';

/**
 * Confirms a template upload once the file has been PUT to blob storage. After
 * this call the template is persisted with an "uploaded" status and shows up in
 * `template/list`. The backend responds with an empty `{}`.
 */
export interface TemplateUploadCompleteProps {
  templateType: TemplateType;
  templateId: string;
}

export type TemplateUploadCompleteResponse = object;

const templateUploadCompleteApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postTemplateUploadComplete: builder.query<TemplateUploadCompleteResponse, TemplateUploadCompleteProps>({
      query: ({ templateType, templateId }: TemplateUploadCompleteProps) => {
        const queryString = buildQueryString(
          { templateType, templateId },
          { templateType: 'template_type', templateId: 'template_id' },
        );
        return {
          url: `template/upload-complete?${queryString}`,
          method: 'POST',
          body: {
            templateType,
            template_id: templateId,
          },
        };
      },
      // Refresh any cached list for this type (admin table + case download menus).
      async onQueryStarted({ templateType }, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(api.util.invalidateTags([{ type: TEMPLATE_LIST_TAG, id: templateType }]));
        } catch (error) {
          console.error('Error in postTemplateUploadComplete in onQueryStarted:', error);
        }
      },
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyPostTemplateUploadCompleteQuery } = templateUploadCompleteApi;
